import { asyncConnect } from 'redux-connect';
import loadable from '@loadable/component';
import {
  getBriefsHash,
  isBriefsLoaded,
  loadBriefs,
} from 'redux/modules/projects2';
import {
  isLoaded as isSuggestedRolesLoaded,
  load as loadSuggestedRoles,
} from 'redux/modules/suggestedRoles2';

const JobCategoriesBase = loadable(() => import('./JobCategoriesBase'));

const EMPTY_EXPERIENCE_LEVELS = [];
const EMPTY_HIRING_CAPACITIES = [];
const EMPTY_ROLES = [];

const JobCategories = asyncConnect(
  [
    {
      promise: ({ store: { dispatch, getState } }) => {
        const promises = [];

        if (!isSuggestedRolesLoaded(getState())) {
          promises.push(dispatch(loadSuggestedRoles()));
        }

        if (
          !isBriefsLoaded(
            getState(),
            true,
            EMPTY_ROLES,
            EMPTY_EXPERIENCE_LEVELS,
            EMPTY_HIRING_CAPACITIES,
            true,
            false,
            false,
            null,
            null
          )
        ) {
          promises.push(
            dispatch(
              loadBriefs(
                1,
                true,
                EMPTY_ROLES,
                EMPTY_EXPERIENCE_LEVELS,
                EMPTY_HIRING_CAPACITIES,
                true,
                false,
                false,
                null,
                null
              )
            )
          );
        }

        return Promise.all(promises);
      },
    },
  ],
  (state) => {
    const roleIds = state.suggestedRoles2.suggestedRoles || [];
    const roleEntities = state.entities.roles || {};
    const roles = roleIds
      .map((id) => roleEntities[id] || roleEntities[String(id)])
      .filter(Boolean);

    const briefsHash = getBriefsHash(
      true,
      EMPTY_ROLES,
      EMPTY_EXPERIENCE_LEVELS,
      EMPTY_HIRING_CAPACITIES,
      true,
      false,
      false,
      null,
      null
    );
    const briefBucket =
      (state.projects2 &&
        state.projects2.briefs &&
        state.projects2.briefs[briefsHash]) ||
      {};
    const briefIds = briefBucket.briefs || [];
    const briefEntities = (state.entities && state.entities.briefs) || {};
    const latestJobs = briefIds
      .slice(0, 5)
      .map((id) => briefEntities[id] || briefEntities[String(id)])
      .filter(Boolean);

    return {
      roles,
      latestJobs,
    };
  }
)(JobCategoriesBase);

export default JobCategories;
